/**
 * @description 元素权限配置, 支持AND、OR两种逻辑, 格式 ['115', ['007', '008'], 'OR/AND']
 */

const directive = {
  inserted: function (el, binding) {
    const hint = `错误语法, eg: v-hasPermi="['115', ['007', '008'], 'OR']"或者v-hasPermi="['115', ['007', '008'], 'AND']"`
    const getElementCode = (code) => {
      const currentWorkList = JSON.parse(window.sessionStorage.getItem('work_list'))
      for (let workItem of currentWorkList) {
        if (workItem.name === code) {
          return workItem.element_codes
        }
      }
      return []
    }
    if (!binding.value) {
      return
    } else if (binding.value.length === 3) {
      const elementCode = getElementCode(binding.value[0])
      const rel = binding.value[2] // 逻辑
      const ec = binding.value[1] // 具体的权限值
      // 记录匹配的权限
      const tmp = new Set()
      ec.forEach((item) => {
        if (elementCode.includes(item)) {
          tmp.add(item)
        }
      })
      // OR逻辑只要有一个则通过
      // AND逻辑只有少一个则不通过
      if (rel === 'OR' && tmp.size === 0) {
        el.parentNode && el.parentNode.removeChild(el)
      } else if (rel === 'AND' && tmp.size < ec.length) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(hint)
    }
  }
}

export default directive
